import { memo } from "react";

export const AfterHoursDetails = memo(function AfterHoursDetails() {
  return null;
});
